/**
 * THE NATIVE CHROME FOLLOWS THE THEME (docs/plans/DARK-MODE.md §6.4): the
 * status bar, the Android navigation bar and the iOS keyboard. One call,
 * made by the theme store on every change and by the safe-area service once
 * the bars are ready. Light does exactly what the app did before dark mode
 * existed (white bars, dark icons; D10). Replaces two dead helpers in
 * safearea.service.ts, one of which had the icon style inverted.
 *
 * The splash is not here: it paints before any JS (platform limit, §9).
 */
import { Capacitor } from '@capacitor/core';
import { Keyboard, KeyboardStyle } from '@capacitor/keyboard';
import { StatusBar, Style } from '@capacitor/status-bar';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { BODY_COLOUR, NAV_SURFACE_DARK, type ResolvedTheme } from './theme';

export async function applyNativeChrome(resolved: ResolvedTheme): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  const dark = resolved === 'dark';
  const bar = BODY_COLOUR[resolved];
  try {
    if (Capacitor.getPlatform() === 'android') {
      if (dark) {
        await EdgeToEdge.setStatusBarColor({ color: bar });
        await EdgeToEdge.setNavigationBarColor({ color: NAV_SURFACE_DARK });
      } else {
        await EdgeToEdge.setBackgroundColor({ color: bar });
      }
    } else {
      await StatusBar.show();
      await StatusBar.setBackgroundColor({ color: bar });
      await StatusBar.setOverlaysWebView({ overlay: false });
      await Keyboard.setStyle({ style: dark ? KeyboardStyle.Dark : KeyboardStyle.Light });
    }
    // Style.Dark = light icons (for a dark bar); Style.Light = dark icons.
    await StatusBar.setStyle({ style: dark ? Style.Dark : Style.Light });
  } catch (error) {
    console.error('Error applying native chrome:', error);
  }
}
